import { createContext, type FC, type PropsWithChildren, useMemo } from 'react';
import { useGetJobConfigCountsQuery } from '@matrix-forge/graphql-client';

export type JobConfigCountsContextValue = {
  data: ReturnType<typeof useGetJobConfigCountsQuery>['data'];
  refetch: () => any;
};

export const JobConfigCountsContext = createContext<JobConfigCountsContextValue | undefined>(
  undefined
);

interface JobConfigCountsProviderProps extends PropsWithChildren {
  pollInterval?: number | null;
}

export const JobConfigCountsProvider: FC<JobConfigCountsProviderProps> = ({
  pollInterval = 60000, // 60 seconds
  children,
}) => {
  const query = useGetJobConfigCountsQuery({
    pollInterval: pollInterval || 0,
  });
  const data = query.data || query.previousData;
  const value = useMemo(
    () => ({
      data,
      refetch: query.refetch,
    }),
    [data, query.refetch]
  );

  return <JobConfigCountsContext value={value}>{children}</JobConfigCountsContext>;
};
